import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class DiarioTag extends Serializable {
    @jsonProperty(Number)
    id: number = -1;

    @jsonProperty(String)
    descricao: string = '';

    constructor() {
        super();
    }
}

export default DiarioTag;
